import {WlOption} from "./option.component";

export * from './option.component';
export default WlOption;

customElements.define('wl-option', WlOption);
